<template>
  <v-container>
    <v-container id="printMe" v-show="false">
      <v-layout row >
      <v-flex xs12 sm6 md1 style="display:inline-block;">
        <img style="margin-left:25px;" src="/static/logo-usac.png" width="120" height="120"/>
      </v-flex>
      <v-flex xs12 sm6 md8 style="display:inline-block; margin-top:15px;">
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">UNIVERSIDAD SAN CARLOS DE GUATEMALA</p>
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">CENTRO UNIVERSITARIO DE SAN MARCOS</p>
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">OFICINA DE REGISTRO Y CONTROL ACADEMICO</p>
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">CONSTANCIA DE ASIGNACION DE CURSOS {{datosAsignacion.semestre.toUpperCase()+" "+datosAsignacion.cohorte}}</p>  
      </v-flex>
      </v-layout>
      <v-layout row >
      <v-flex xs12 sm12 md12 style="display:block; margin-top:5px; margin-left:-30px;">
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">No. CARNE: {{datosAsignacion.carne}}</p>
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">NOMBRE ESTUDIANTE: {{datosAsignacion.estudiante.toUpperCase()}}</p>
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">CARRERA: {{datosAsignacion.carrera.toUpperCase()}}</p>
        <p style="display:inline-block; margin: 0 !important; margin-left:70px !important; padding: 0 !important;">CODIGO: {{datosAsignacion.idcarrera}} </p>  
        <p style="display:inline-block; margin: 0 !important; margin-left:70px !important; padding: 0 !important;">CODIGO PENSUM: {{datosAsignacion.pensum}} </p>  
      </v-flex>
      </v-layout>
      <v-layout row style="margin-top:20px; margin-left:25px; display:block;">
        <v-flex xs12 sm12 md12>
          <table style="border-collapse: collapse; width: 90%;">
          <tr>
            <th style="border: 1px solid black; margin: 0 !important; margin-left:45px !important; padding: 0 !important;">No.</th>
            <th style="border: 1px solid black; margin: 0 !important; margin-left:45px !important; padding: 0 !important;">CODIGO</th> 
            <th style="border: 1px solid black; margin: 0 !important; margin-left:45px !important; padding: 0 !important;">NOMBRE DEL CURSO</th>
            <th style="border: 1px solid black; margin: 0 !important; margin-left:45px !important; padding: 0 !important;">SECCION</th>
          </tr>
          <tr v-for="(item, key) in asignacion">
            <td style="border: 1px solid black; padding:5px;">{{key+1}}</td>
            <td style="border: 1px solid black; padding:5px;">{{ item.idcurso }}</td> 
            <td style="border: 1px solid black; padding:5px;">{{ item.curso }}</td>
            <td style="border: 1px solid black; padding:5px;">{{ item.seccion }}</td>
          </tr>
        </table>
        </v-flex>
      </v-layout>
      <v-layout row >
      <v-flex xs12 sm12 md12 style="display:block; margin-top:55px; margin-left:-30px;">
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">FIRMA DEL ESTUDIANTE: ___________________________________________________________.</p>
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important; margin-top:35px !important;">OBSERVACIONES: FIRMO CONSIDERANDO ESTO COMO UNA DECLARACION JURADA DE LO QUE ME ASIGNE EN EL SISTEMA.</p>
      </v-flex>
      <v-flex xs12 sm12 md12 style="display:block; margin-top:105px; margin-left:-30px;">
        <p style="margin: 0 !important; margin-left:70px !important; padding: 0 !important;">FECHA DE IMPRESION: {{new Date().toLocaleDateString()}} </p>
      </v-flex>
      </v-layout>

    
    </v-container>
    <v-toolbar flat color="white">
      <v-toolbar-title>Evaluación a docentes - {{datosAsignacion.estudiante}}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn small @click="print" :disabled="!impresionActiva">Imprimir Asignación</v-btn>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>
    <v-data-table
      :headers="computedHeaders"
      :items="asignacion"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :total-items="pagination.totalItems"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td v-if="false">{{ props.item.id }}</td>
        <td>{{ props.item.docente }}</td>
        <td>{{ props.item.curso }}</td>
        <td>{{ props.item.cohorte }}</td>
        <td>{{ props.item.semestre }}</td>
        <td>{{ props.item.seccion }}</td>
        <td>{{ props.item.carrera }}</td>
        <td class="justify-center">
          <v-icon
            v-if="periodo_abierto===true && props.item.finalizada===false"
            medium
            class="mr-2"
            @click="abrirEvaluacion(props.item)"
          >assignment</v-icon>
          <p style="font-weight:bold;" v-if="periodo_abierto===false">No existe evaluacion abierta</p>
          <p style="font-weight:bold; color: green;" v-if="props.item.finalizada===true">Evaluación realizada</p>
        </td>
      </template>
      <template v-slot:no-data>
        <h4>{{mensaje}}</h4>
      </template>
    </v-data-table>
     
  </v-container>
  
</template>

<script>
import { debuglog } from "util";
import Vue from "vue";
export default {
  data: () => ({

    asignacion: [],
    impresionActiva:false,
    loading:false,
    periodo_abierto: null,
    mensaje: "Buscando datos de asignación",
    datosAsignacion:{
      semestre: "",
      carrera:"",
      idcarrera:"",
      estudiante:"",
      carne:"",
      cohorte:"",
      pensum:""
    },
    headers: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "id"
      },
      {
        text: "Docente",
        align: "left",
        sortable: true,
        value: "docente"
      },
      {
        text: "Curso",
        align: "left",
        sortable: true,
        value: "curso"
      },
      {
        text: "Cohorte",
        align: "left",
        sortable: true,
        value: "cohorte"
      },
      {
        text: "Semestre",
        align: "left",
        sortable: true,
        value: "semestre"
      },
      {
        text: "Sección",
        align: "left",
        sortable: true,
        value: "sección"
      },
      {
        text: "Carrera",
        align: "left",
        sortable: true,
        value: "carrera"
      },
      {
        text: "Evaluar",
        align: "left",
        sortable: true,
        value: "link"
      }
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [10]
    }
  }),

  computed: {
    computedHeaders() {
      return this.headers.filter(header => header.text !== "Id");
    }
  },

  created() {
    this.$store.asignacion = [];
    this.ready();
  },

  updated(){
   
  },

  methods: {
    getAsignacion() {
      const that = this;
      this.$store.state.asignacion = [];
      that.loading=true;
        Vue.axios.get(this.$store.state.endpoints.baseUrl + "asignacion/", {
                params: {
                    carne: localStorage.getItem('u'),
                }
            })
            .then(response => {
                
                let periodo = response.data.periodo_abierto;
                let results = response.data.results;
                let total = response.data.count;
                let next = response.data.next;
                let previous = response.data.previous;
                var encabezado_data = response.data;
                that.asignacion = results;
                that.periodo_abierto = periodo;
                that.datosAsignacion.semestre = encabezado_data.semestre;
                that.datosAsignacion.carrera = encabezado_data.carrera;
                that.datosAsignacion.idcarrera = encabezado_data.idcarrera;
                that.datosAsignacion.estudiante = encabezado_data.nombre;
                that.datosAsignacion.carne = encabezado_data.carne;
                that.datosAsignacion.cohorte = encabezado_data.cohorte;
                that.datosAsignacion.pensum = encabezado_data.pensum;
                that.impresionActiva = encabezado_data.impresion_permitida;
                
                if(that.asignacion.length > 0){
                  that.loading=false
                }
                else{
                  that.loading=false;
                  that.mensaje="No se encontraron datos de asignación";
                }
                that.$forceUpdate();

            })
            .catch(error => {
              debugger;
                if (error.request.status === 401) {
                    this.commit('removeToken');
                    router.push("/login");
                }
            });
        },
    abrirEvaluacion: function(item) {
      window.open(item.link, "_blank");
      this.initialize();
    },
    print() {
      this.$htmlToPaper('printMe');
    },
    ready: function () {
      
      this.getAsignacion(); 
      if(this.asignacion.length > 0){ 
        if(this.impresionActiva === false){
          this.interval = setInterval(function () {
            this.initialize();
          }.bind(this), 20000); 
        }
        else{
          clearInterval(this.interval);
        }
      }
    },

    beforeDestroy: function(){
      clearInterval(this.interval);
    }
  }
  
};
</script>
